import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ActionsService {

  zuperUpdateNodeData: any = {
    action_key: 'zuper_update',
    action_name: 'Edit Record',
    action_type: 'ACTION',
    credentials: {},
    form_fields: {},
    input: 1,
    output: 1,
    is_active: true,
    module: '',
    node_description: 'Update an entity in Zuper',
    node_display_name: 'Edit Record',
    node_name: 'zuper_update',
    node_uid: '7bd69fec-b465-4eb8-a94b-3158c252921c',
    node_icon: 'https://s3.ap-south-1.amazonaws.com/staging.in.pro.zuper/attachments/6c287db0-ff7c-11e7-b3a8-29b417a4f3fa/283a4296-e481-48b5-be1d-8c20de718d2d.svg',
    params: {},
    version: '0.0.1'
  }

  zuperCreateNodeData: any = {
    action_key: 'zuper_create',
    action_name: 'Create Record',
    action_type: 'ACTION',
    credentials: {},
    form_fields: {},
    input: 1,
    output: 1,
    is_active: true,
    module: '',
    node_description: 'Add an entity in Zuper',
    node_display_name: 'Create Record',
    node_name: 'zuper_create',
    node_uid: '03bbfb40-884b-Dsdsadas-80d6-8baf5818d53c',
    node_icon: 'https://s3.ap-south-1.amazonaws.com/staging.in.pro.zuper/attachments/6c287db0-ff7c-11e7-b3a8-29b417a4f3fa/283a4296-e481-48b5-be1d-8c20de718d2d.svg',
    params: {},
    version: '0.0.1'
  }

    zuperGetNodeData: any = {
    action_key: 'zuper_get_record',
    action_name: 'Get Record',
    action_type: 'ACTION',
    credentials: {},
    form_fields: {},
    input: 1,
    output: 1,
    is_active: true,
    module: '',
    node_description: 'Get a Record in Zuper',
    node_display_name: 'Edit Record',
    node_name: 'zuper_get_record',
    node_uid: '7bd69fec-sudhaid65-4eb8-a94b-3158c252921c',
    node_icon: 'https://s3.ap-south-1.amazonaws.com/staging.in.pro.zuper/attachments/6c287db0-ff7c-11e7-b3a8-29b417a4f3fa/283a4296-e481-48b5-be1d-8c20de718d2d.svg',
    params: {},
    version: '0.0.1'
  }

  zuperCustomFieldCopyData: any = {
    action_key: 'zuper_custom_field',
    action_name: 'Copy Custom fields',
    action_type: 'ACTION',
    credentials: {},
    form_fields: {},
    input: 1,
    output: 1,
    is_active: true,
    module: '',
    node_description: 'Associate custom field value across modules',
    node_display_name: 'Copy Custom fields',
    node_name: 'zuper_custom_field',
    node_uid: 'bc1a13d1-e464-4711-bc24-5853fab2aac1',
    node_icon: 'https://s3.ap-south-1.amazonaws.com/staging.in.pro.zuper/attachments/6c287db0-ff7c-11e7-b3a8-29b417a4f3fa/a86f39e0-aca7-4059-9373-10ba63a251d2.svg',
    params: {},
    version: '0.0.1'
  }

  constructor() { }
}
